import Debug from "debug";
Debug.enable("main.js, router/index.js, store/index.js, services/index.js");
const debug = Debug("main.js");

import Vue from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";

// ----------------------------------------------------
import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
// ----------------------------------------------------

// ----------------------------------------------------
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
// ----------------------------------------------------

// ----------------------------------------------------
import Axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, Axios);
const token = localStorage.getItem("token");
if (token !== "") {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}
debug(`JWT Token : ${token}`);
// ----------------------------------------------------

// ----------------------------------------------------
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser,
  faUserCog,
  faKey,
  faEnvelope,
  faEnvelopeSquare,
  faSignOutAlt,
  faCog,
  faSearch,
  faPlusCircle,
  faUserPlus,
  faCheck,
  faPhone,
  faPlus,
  faMinus,
  faMinusCircle,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faUser,
  faUserCog,
  faKey,
  faEnvelope,
  faEnvelopeSquare,
  faSignOutAlt,
  faCog,
  faSearch,
  faPlusCircle,
  faUserPlus,
  faCheck,
  faPhone,
  faPlus,
  faMinus,
  faMinusCircle,
  faEdit,
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
// ----------------------------------------------------

// ----------------------------------------------------
import services from "./services/index";
Vue.prototype.$services = services;
// ----------------------------------------------------

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
